import React from "react";
import Video from "../../main/Video";
import BackButton from "../../main/BackButton";

const HowToShop = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/u68i7mx6qq`}
        maxHeight="80%"
      />
    </>
  );
};

export default HowToShop;
